import api from './client';
import ApiError from './error';

const AccountService = {
  async getAccount({ id }) {
    try {
      const client = await api.getClient();
      return client.getAccount(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async searchUserCollection({ params }) {
    try {
      const client = await api.getClient();

      if (!params) {
        params = {};
      }

      return client.searchAccounts(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async searchAccountTransactions(params) {
    try {
      const client = await api.getClient();

      if (!params) {
        params = {};
      }

      if (params.account) {
        params.account = `${params.account}`;
      }

      if (params.from) {
        params.from = `${params.from}`;
      }

      if (params.to) {
        params.to = `${params.to}`;
      }

      return client.searchCardTransaction(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateLocationConfig({
    news, events, googleApiKey, suggestionTitles, airQualityStations, email,
  }) {
    const data = {};

    if (news) {
      data['/news/endpoint'] = news;
    }
    if (events) {
      data['/calendar/endpoint'] = events;
    }
    if (googleApiKey) {
      data['/google/api-token'] = googleApiKey;
    }
    if (suggestionTitles) {
      data['/suggestions/titles'] = suggestionTitles;
    }
    if (airQualityStations) {
      data['/airQuality/stations'] = airQualityStations;
    }
    if (email) {
      data['/cards/purchase-notification-email'] = email;
    }
    try {
      const client = await api.getClient();
      return client.updateLocationConfig(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
  async getLocationConfig() {
    try {
      const client = await api.getClient();
      return client.getLocationConfig();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
  async getLocations() {
    try {
      const client = await api.getClient();
      return client.getLocations();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default AccountService;
